import { useEffect, useState } from 'react'

import styled from 'styled-components'

import { AnimatedChildrenContainer } from 'components/AnimatedChildrenContainer'
import { Button } from 'components/Button'
import { IconSyncProblemOutline } from 'components/icons'
import { Text, Title } from 'components/typography'
import { useLocaleTranslation } from 'hooks/useLocaleTranslation'
import { easeOutQuart } from 'theme/animations'
import { gaSendCustomEvent } from 'utils/helpers/analytics'
import { PageEventType, usePageEventTracking } from 'utils/rudderstack'

const Container = styled.div`
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.error {
    & div.logo {
      transition-delay: 0;
      transition: transform 1000ms ${easeOutQuart};
      transform: scale(0.4);
    }
  }
`

export const PlayerError = () => {
  const { _ } = useLocaleTranslation('Player')
  const [loaded, setLoaded] = useState(false)
  usePageEventTracking({
    pageName: PageEventType.SYNC_ERROR,
  })

  const reloadApp = () => {
    gaSendCustomEvent('reloading')
    window.location.reload()
  }

  useEffect(() => {
    // Make sure the animations always run
    const tm = setTimeout(() => {
      setLoaded(true)
    }, 100)
    return () => clearTimeout(tm)
  }, [])

  return (
    <>
      <Container>
        <AnimatedChildrenContainer $show={loaded}>
          <IconSyncProblemOutline size={10} />
          <Title>{_('error-title')}</Title>
          <Text>{_('error-message')}</Text>
          <Button onClick={reloadApp}>{_('reload-button')}</Button>
        </AnimatedChildrenContainer>
      </Container>
    </>
  )
}
